import React, { useEffect, useReducer, useState } from 'react'
import { CSVLink } from 'react-csv'
import { Modal, ModalBody } from "react-bootstrap";
import GridColumnHeader from '../../Setup/Shared/GridColumnHeader';

const DataTable = (props) => {
    const { isOpenPopup, onClose, ID, saveData } = props;

    const ExtractedData = saveData?.map((item) => {
        const { PatientID, ID: id, ...restOfObj } = item;
        return restOfObj
    });

    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: [], activeSortIcon: '' })

    const [appointmentData, setAppointmentData] = useState(ExtractedData ? ExtractedData : []);

    useEffect(()=>{
        handleGridHeader({ defaultData: ExtractedData ? ExtractedData : [] })
    },[saveData])

    return (
        <Modal show={isOpenPopup} onHide={isOpenPopup} backdrop="static" keyboard={false} centered dialogClassName=" hk-modal-v1  za-subscriber-id za-bulk-claims-result">
            <Modal.Body>
                <div className='d-flex justify-content-between align-items-center mb-12 px-10'>

                    <p className='heading dark-clr fs-14'>Result</p>
                    <div className='d-flex  align-items-center gap-2'>
                        <CSVLink filename={"Recurring.csv"} data={ExtractedData}><i className='icon-Group-482289'></i></CSVLink>
                        <i className='icon-x-cros fs-20 dark-clr' onClick={() => onClose()} ></i>
                    </div>

                </div>

                <div className='card-body hk-expand-table ad-expand-table service_line pb-2 mt-2 px-10'>
                    <table>
                        <thead>
                            <tr>
                                <th className='heading fs-12'>

                                    <GridColumnHeader
                                        gridHeader={gridHeader}
                                        handleGridHeader={handleGridHeader}
                                        iconName={""}
                                        headerName={"Patient Name"}
                                        sortIcon={true}
                                        type={"string"}
                                        colKey={"Patient"}
                                        data={appointmentData}
                                        setData={setAppointmentData}
                                    />

                                </th>
                                <th className='heading fs-12'>
                                    <GridColumnHeader
                                        gridHeader={gridHeader}
                                        handleGridHeader={handleGridHeader}
                                        iconName={""}
                                        headerName={"Appointment Date"}
                                        sortIcon={true}
                                        type={"date"}
                                        colKey={"AppointmentDate"}
                                        data={appointmentData}
                                        setData={setAppointmentData}
                                    />
                                </th>
                                <th className='heading fs-12'>
                                    <GridColumnHeader
                                        gridHeader={gridHeader}
                                        handleGridHeader={handleGridHeader}
                                        iconName={""}
                                        headerName={"Appointment Time"}
                                        sortIcon={true}
                                        type={"string"}
                                        colKey={"AppointmentStart"}
                                        data={appointmentData}
                                        setData={setAppointmentData}
                                    />
                                </th>
                                <th className='heading fs-12'>
                                    <GridColumnHeader
                                        gridHeader={gridHeader}
                                        handleGridHeader={handleGridHeader}
                                        iconName={""}
                                        headerName={"Appointment Status"}
                                        sortIcon={true}
                                        type={"string"}
                                        colKey={"Status"}
                                        data={appointmentData}
                                        setData={setAppointmentData}
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {appointmentData?.map((data, idx) => (<>

                                <tr>
                                    <td className='text fs-12'>{data?.Patient}</td>
                                    <td className='text fs-12'>{data?.AppointmentDate}</td>
                                    <td className='text fs-12'>{data?.AppointmentStart}</td>
                                    <td className='text fs-12'>{data?.Status}</td>

                                </tr>

                            </>))}

                            {/* <tr>
                                        <td className='text fs-12'>John Axe</td>
                                        <td className='text fs-12'></td>
                                        <td className='text fs-12'></td>
                                        <td className='text fs-12 text-nowrap'></td>
                                        <td className='text fs-12'></td>
                                        <td className='text fs-12 text-nowrap'></td>
                                        <td className='text fs-12'></td>
                                    </tr>
                                    <tr>
                                        <td className='text fs-12'>Smith, Panes</td>
                                        <td className='text fs-12'></td>
                                        <td className='text fs-12'></td>
                                        <td className='text fs-12 text-nowrap'></td>
                                        <td className='text fs-12'></td>
                                        <td className='text fs-12 text-nowrap'></td>
                                        <td className='text fs-12'></td>
                                    </tr> */}

                        </tbody>
                    </table>
                </div>
                {/* <div className='br-top-1 br-clr'></div>
                <div className="modal_footer  ar-border-color">
                    <div className="text-end">
                        <div className="btns-group">
                            <button className="btn btn-orange heading fs-12 text-white" onClick={() => onClose()}>close</button>
                        </div>
                    </div>
                </div> */}

            </Modal.Body>

            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                <button className='btn btn-validate px-10 h-100' onClick={() => onClose()}> Close</button>
            </div>
        </Modal>
    )
}

export default DataTable
